import { gray, green, orange, purple, volcano } from '@ant-design/colors';
import { theme } from 'antd';

export const MIN_WIDTH = 1150;
export const COMPACT_MODE_MIN_WIDTH = 1700;
export const TAB_BAR_HEIGHT = 60;
export const SIDEBAR_PLUGIN_WIDTH = 330;
export const MAIN_SIDEBAR_WIDTH = 60;
export const TICKET_SIDEBAR_WIDTH = 390;
export const TICKET_FOOTER_HEIGHT = 56;
export const FILTERS_SIDEBAR_WIDTH = 350;
export const ADVANCED_REPORT_SIDEBAR_WIDTH = 370;
export const ADVANCED_REPORT_SIDEBAR_COLLAPSED_WIDTH = 50;
export const FILTERS_SIDEBAR_COLLAPSED_WIDTH = 50;
export const ADMIN_SIDEBAR_WIDTH = 250;
export const PRIMARY_COLOR = '#632d91';
export const TICKET_STATUS_COLOR_NEW = orange.primary;
export const TICKET_STATUS_COLOR_OPEN = volcano.primary;
export const TICKET_STATUS_COLOR_PENDING = purple.primary;
export const TICKET_STATUS_COLOR_ON_HOLD = gray[7];
export const TICKET_STATUS_COLOR_SOLVED = green[7];
export const TICKET_STATUS_COLOR_CLOSED = gray.primary;

export const tagBackgroundColors = {
    New: TICKET_STATUS_COLOR_NEW,
    Open: TICKET_STATUS_COLOR_OPEN,
    Pending: TICKET_STATUS_COLOR_PENDING,
    'On Hold': TICKET_STATUS_COLOR_ON_HOLD,
    Solved: TICKET_STATUS_COLOR_SOLVED,
    Closed: TICKET_STATUS_COLOR_CLOSED
} as const;

export const defaultThemeConfig = {
    algorithm: theme.defaultAlgorithm,
    token: {
        colorPrimary: PRIMARY_COLOR,
        colorInfo: PRIMARY_COLOR
    },
    components: {}
};
